<template>
  <div class="toggle-switch">
    <a
      href="#p"
      v-for="(item, i) in switchList"
      :key="item.value"
      v-text="item.label"
      :class="['px-m', item.value === value ? 'active' : '']"
      @click.prevent="activateItem(item.value, i)"
    >
    </a>
    <!-- <span :style=" `width:${itemWidths[activeIndex] + (slabNudge ? 1 : 0)}px;${slabPos};`" class="active-slab"></span> -->
  </div>
</template>

<script>
export default {
  props: {
    locale:{
      type:String,
      default:'EN'
    },
    switchList: {
      required: true,
      type: Array
    },
    value: {
      type: [String, Number, Object, Date, Boolean]
    },
    // Reference to state property (vuex)
    // that holds the active value.
    stateRef: Number
  },
  data() {
    return {
      activeIndex: 0,
      itemWidths: [],
      slabNudge: false
    };
  },
  mounted() {
    var vm=this;
    setTimeout(() => 
    {
      //alert(vm.locale);
      vm.initItems();
      vm.compareToRef();
      window.addEventListener("resize", vm.initItems, false);      
    }, 100);
  },
  destroyed() {
    window.removeEventListener("resize", this.initItems, false);
  },
  methods: {
    compareToRef() {
      if (this.stateRef !== this.value) {
        let item = _.find(this.switchList, { value: this.stateRef });
        this.activateItem(item.value, this.stateRef - 1);
      }
    },
    initItems() {
      this.$nextTick(function() {
        setTimeout(
          function() {
            let listElements = this.$el.querySelectorAll("a");
            this.itemWidths = _.map(listElements, el => el.offsetWidth);
          }.bind(this),
          300
        );
      });
    },
    activateItem(v, i) {
      this.$emit("input", v);
      this.activeIndex = i;
    }
  },
  computed: {
    slabPos()
    {
      if(this.locale=='HE')
      {
          return 'right:'+this.slabLeft+'px;'
      }else{
          return 'left:'+this.slabLeft+'px;'
      }
      
    },
    slabLeft() {
      return _.sum(this.itemWidths.slice(0, this.activeIndex));
    }
  }
};
</script>

<style lang="stylus" scoped>
.active-slab
  will-change left, width
  transition left 0.15s ease-out-back, width 0.25s ease-out-back
.toggle-switch
  height 44px
  border 1px solid gray_5
  padding 4px
  border-radius 22px
  display inline-block
  position relative
  overflow hidden
  _flex(row, wrap, center, center)
  z-index 1
  a
    transition background 0.3s ease-out-back, color 0.3s ease-out-back
    border-radius 18px
    flex 1
    text-align center
    display block
    height 32px
    line-height 32px
    color gray_7
    &.active
      color #fff
      pointer-events none
      background blue_brand
  .active-slab
    position absolute
    background blue_brand
    margin-left 3px
    margin-right 3px
    left 0
    top 3px
    width 97%
    z-index -1
    border-radius 18px
    flex 1
    text-align center
    display block
    height 36px
    line-height 30px
</style>
